export const hostedItemPriceCents = 1900
